<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="对账单"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="学校名称">
          <el-select size="mini" v-model="params.SchoolId" clearable @change="query()">
            <el-option v-for="item in schoolList" :key="item.SchoolId" :value="item.SchoolId" :label="item.SchoolName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型">
          <el-input v-model="params.LogType" size="mini" placeholder="请填写类型"/>
        </el-form-item>
        <el-form-item label="银行名称">
          <el-input v-model="params.BankName" size="mini" placeholder="请填写银行名称"/>
        </el-form-item>
        <el-form-item label="学号">
          <el-input v-model="params.StudentNumber" size="mini" placeholder="请填写学号"/>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="SchoolName" label="学校名称" min-width="120"/>
        <el-table-column prop="LogType" label="类型"/>
        <el-table-column prop="BankName" label="银行名称"/>
        <el-table-column prop="FullName" label="姓名"/>
        <el-table-column prop="StudentNumber" label="学号"/>
        <!-- <el-table-column prop="ContactNumber1" label="电话一" min-width="110"/>
        <el-table-column prop="Call2" label="电话二" min-width="110"/>
        <el-table-column prop="ContactNumber3" label="电话三" min-width="110"/> -->
        <el-table-column prop="Amount" label="金额"/>
        <el-table-column prop="LogTime" label="时间" min-width="140" />
        <el-table-column prop="RechargeTime" label="银行操作时间" min-width="140"/>
        <slot name="column"></slot>
      </template>
    </list>
    <export-dialog ref="exportDialog" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import exportDialog from "./exportDialog";

export default {
  mixins: [listMixin],
  components: { list,exportDialog },
  data() {
    return {
      api: require("@/api/consume/banklog").default,
      schoolApi: require("@/api/st/school").default,
      params: {
        SchoolId: null,
        LogType: "",
        BankName: "",
        StudentNumber: "",
      },
      schoolList: [],
    };
  },
  beforeMount() {
    this.schoolApi.list({ Status: 1 }).then(res => {
      if(res.Code == 0) {
        this.schoolList = res.Data;
      }
    })
  },
  methods: {
    export() {
      // this.$refs.exportDialog.open().then((that) => {
      //   that.getData(this.params);
      // });
      // this.api.export(this.$commonJs.obj.removeNullKey(this.params));
      this.api.export(this.$commonJs.obj.removeNullKey(this.$refs.list.tempQueryParams));
    },
  },
};
</script>